import React from "react";
import { Button, Tooltip } from "@mui/material";

interface TableActionButtonProps {
  label: string;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  tooltip?: string;
  variant?: "outlined" | "text" | "contained";
  color?: "primary" | "secondary" | "inherit";
}

/**
 * Consistent action button for use inside data-table cells (Report / View /
 * download …). Keeps every table's row actions visually identical.
 */
const TableActionButton: React.FC<TableActionButtonProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
  tooltip,
  variant = "outlined",
  color = "primary",
}) => (
  <Tooltip arrow title={tooltip || ""} disableHoverListener={!tooltip}>
    <span>
      <Button
        size="small"
        variant={variant}
        color={color}
        disabled={disabled}
        startIcon={icon}
        onClick={(e) => onClick?.(e)}
        sx={{ whiteSpace: "nowrap" }}
      >
        {label}
      </Button>
    </span>
  </Tooltip>
);

export default TableActionButton;
